























import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import { getMany, collection } from 'typesaurus'
import { contains } from 'ramda'
import { getModule } from 'vuex-module-decorators'
import firebase from 'firebase/app'
import dayjs from 'dayjs'
import UserStore from '../store/modules/user'
import LocationStore from '../store/modules/location'
import MainMixin from '../mixins/MainMixin'
import { LocationCollection } from '../types'
import EventBus from '../event-bus'
import AppStore from '../store/modules/app'
import TaskStore from '../store/modules/tasks'

type ListLocation = {
  name: string,
  avatar: string
}
const ListLocations = collection<ListLocation>('locations')

@Component({
  components: {
  },
})
export default class Location extends Mixins(MainMixin) {
  async bindLocation(id:string, name:string) {
    // if (id === 'cobbsmchenry') return ''
    if (this.LocationStore.data.id) {
      // Set status as offline for old location
      await this.AppStore.removeOfflineRef()
    }
    await this.Location.bindLocation(id)
    Vue.prototype.$toast.success(`Successfully Logged Into ${name !== undefined ? name : 'Location'}`)
    Promise.all([
      this.AppStore.setOnlineStatus(),
      this.Location.bindGroup(),
      this.AppStore.appBind(),
      this.UserStore.setLocationUsers(this.$store.getters.location), this.LocationStore.bindNotifications(this.$store.getters.location, this.$store.getters.group),
      this.TaskStore.bindTasks(),
    ])
    return this.$router.push('/welcome')
  }

  UserStore:any = getModule(UserStore)

  LocationStore:any = getModule(LocationStore)

  AppStore:any = getModule(AppStore)

  TaskStore:any = getModule(TaskStore)

  async logout() {
    await this.$store.dispatch('removeOfflineRef')
    firebase.auth().signOut()
  }

  test22() {
    console.log('ok')
  }

  loadingLocations = false

  async mounted() {
    if (!this.LocationStore || !this.LocationStore.data.id) {
      this.loadingLocations = true
      const redirectQuery = this.$route.query.redirectUrl as string || '/welcome'
      console.log('userAuth: ', this.$store.state.user.auth)
      if (this.$store.state.user && this.$store.state.user.auth.locations.length === 1) {
        console.log('here', this.UserStore)
        await this.LocationStore.bindLocation(this.$store.state.user.auth.locations[0])
        Promise.all([this.AppStore.setOnlineStatus(), this.AppStore.appBind(), this.UserStore.setLocationUsers(this.$store.getters.location)])
        return this.$router.push(redirectQuery)
      }
      const storedLocation = window.localStorage.getItem('queryLocation') || window.localStorage.getItem('lastLocation')
      if (storedLocation && this.UserStore.auth && contains(storedLocation, this.UserStore.auth.locations)) {
        return this.$router.push(redirectQuery)
      }
    }
    if (!this.UserStore.auth || !this.UserStore.auth.locationList) {
      this.loadingLocations = true
      const allLocations = await getMany(LocationCollection, this.$store.state.user.auth.locations)
      const locations = allLocations.map(loc => ({ name: loc.data.name, avatar: loc.data.avatar, id: loc.ref.id }))
      this.UserStore.setLocationList(locations)
      this.loadingLocations = false
    }
    return true
  }
}
